
var winWidth   = $(window).width();
var winWidthSm = 992;
var headerId   = $('#js-header');
var headHeight = headerId.outerHeight();

// ios.js
var userAgent = window.navigator.userAgent.toLowerCase();
if ( userAgent.indexOf('ipad') != -1 || userAgent.indexOf('iphone') != -1 ) {
  $('body').addClass('ios');
}


// slideout
var slideout = new Slideout({
  'panel': document.getElementById('js-so-panel'),
  'menu': document.getElementById('js-so-menu'),
  'duration': 10,
});
var nodeList = document.querySelectorAll('#js-so-toggle, #js-so-panel');
var node = Array.prototype.slice.call(nodeList,0);
node.forEach(function(elem, index){
  elem.addEventListener('click', function() {
    slideout.toggle();
  });
});



$(document).ready(function() {

  // ページ内スクロール
  $('.js-scroll:not([href=""])').on('click', function() {
    winWidth  = $(window).width();
    headHeight = headerId.outerHeight();

    var speed = 600;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    if ( winWidthSm <= winWidth ) {
      headHeight = 0;
    }
    console.log(headHeight);

    var position = target.offset().top - headHeight;

    if ( href == '#' ) { position = 0; }
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });


  // objectFitImages
  objectFitImages('img.js-ofi');


});



$(window).on('load scroll', function() {
  var windowHeight = $(window).height(),
      topWindow    = $(window).scrollTop();

  // PC HEADER
  if ( topWindow > 50 ) {
    $('#js-header').addClass('is-act');
  } else {
    $('#js-header').removeClass('is-act');
  }


  // ANIMATION
  $('.js-animate').each(function(){
    var self = $(this),
        targetPosition = self.offset().top,
        triggerPosition;
    if(winWidth >= winWidthSm) {
      triggerPosition = targetPosition - windowHeight + ( windowHeight / 5 );
    } else {
      triggerPosition = targetPosition - windowHeight + ( windowHeight / 10 );
    }
    if( topWindow > triggerPosition ){
      self.addClass("is-anime");
    }
  });
});